import './error-ribbon.scss';

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Component } from 'vue-property-decorator';

@Component({
    template: require('./error-ribbon.html'),
})
export class ErrorRibbon extends ReactiveVue {
    public show = true;
    private subject$ = new Subject();

    public created() {
        this.subscribe();
    }

    public mounted() {
        this.subject$.next();
    }

    private subscribe() {
        this.subscribeTo(this.subject$.pipe(debounceTime(2e3)), () => {
            this.show = false;
        });
    }
}
